import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function EarsIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M10.3605 11.2551V10.6693M10.3605 10.6693C10.3605 9.37567 11.4001 8.3268 12.6829 8.32609C13.9663 8.32539 15.0078 9.37438 15.0078 10.6686C15.0078 11.7794 14.5071 12.8306 13.6469 13.5245C12.6712 14.3116 12.1032 15.5033 12.1032 16.7633V17.113M10.3605 10.6693C10.3605 7.76204 12.7057 5.39712 15.5887 5.39712C18.4717 5.39712 20.8169 7.76204 20.8169 10.6693C20.8169 12.2018 20.1367 13.6297 18.9499 14.5867L17.6241 15.6562C16.4159 16.631 15.5765 17.9717 15.212 19.4561M26.0451 7.1545L20.6866 9.49769M6.875 10.6693V24.2597C6.875 27.4949 9.47581 30.1176 12.6841 30.1176C15.8924 30.1176 18.4932 27.495 18.4932 24.2597V21.1454C18.4932 20.0777 18.9746 19.0679 19.8014 18.4009L21.1271 17.3314C23.1341 15.7124 24.3024 13.2611 24.3024 10.6693C24.3024 5.81638 20.4012 1.88235 15.5887 1.88235C10.7762 1.88235 6.875 5.81638 6.875 10.6693ZM14.4269 24.2597C14.4269 25.2303 13.6466 26.0171 12.6841 26.0171C11.7216 26.0171 10.9414 25.2303 10.9414 24.2597C10.9414 23.2891 11.7216 22.5023 12.6841 22.5023C13.6466 22.5023 14.4269 23.2891 14.4269 24.2597Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
}
